import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatPrice } from '../utils/numbers';

const StyledPrice = styled.div`
  text-align: inherit;
`;

const Amount = styled.div`
  color: ${p => (p.dark ? p.theme.colors.darkFont : p.theme.colors.primary)};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.2px;
  text-transform: uppercase;
`;

const Shipping = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
`;

const Suffix = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2px;
`;

export default function Price({ amount, shipping, dark, className }) {
  if (!amount || amount <= 0) return null;

  return (
    <StyledPrice className={className}>
      <Amount dark={dark}>{formatPrice(amount)}</Amount>
      {shipping && <Shipping>Frakt: {formatPrice(shipping)}</Shipping> || ''}
      <Suffix>Inkl. MVA</Suffix>
    </StyledPrice>
  );
}

Price.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shipping: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dark: PropTypes.bool
};
